/**
 * Women's Breakfasts page: Женские завтраки — встреча сердец и душевное общение.
 * Static content, events to be added later.
 */

import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Layout } from "../../components/layout/index.ts";
import {
  IconClock,
  IconMapPin,
  IconChevronRight,
} from "../../components/Icons.tsx";
import { getTelegram } from "../../lib/telegram.ts";

const BODY_TEXT = `Приглашаем тебя провести утро в атмосфере вдохновения и душевного общения 💛

Это больше, чем просто завтрак — это встреча сердец, разговоры по душам и возможность укрепиться в вере и любви.

☕️ Тёплая атмосфера
🥐 Вкусное угощение
💬 Живое общение
🙏 И немного духовных откровений

📅 Регистрация на женский завтрак открыта!

Жми кнопку ниже и забронируй своё место прямо сейчас`;

function buildImageUrl(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;
  if (url.startsWith("http")) return url;
  return url.startsWith("/") ? url : `/${url}`;
}

export function WomensBreakfastsPage() {
  const navigate = useNavigate();
  const tg = getTelegram();
  const imageUrl = buildImageUrl("/content/woman-breakfast.png");

  useEffect(() => {
    if (!tg) return;
    tg.BackButton.show();
    const handleBack = () => {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate("/");
      }
    };
    tg.BackButton.onClick(handleBack);
    return () => {
      tg.BackButton.offClick(handleBack);
      tg.BackButton.hide();
    };
  }, [tg, navigate]);

  return (
    <Layout>
      <h1 className="text-xl font-bold text-slate-800 mb-4">
        Женские завтраки
      </h1>

      {/* Hero image */}
      {imageUrl ? (
        <div className="aspect-[4/3] overflow-hidden rounded-2xl mb-4 shadow-sm border border-slate-100 ring-1 ring-slate-200/50 bg-slate-100">
          <img src={imageUrl} alt="" className="w-full h-full object-cover" />
        </div>
      ) : null}

      {/* Description */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 mb-4 border border-slate-100">
        <p className="text-slate-600 text-sm leading-relaxed whitespace-pre-wrap prose prose-slate prose-sm max-w-none">
          {BODY_TEXT}
        </p>
      </div>

      {/* Когда и где — по картинке: каждый вторник 11:00–13:00 */}
      <div className="rounded-2xl overflow-hidden bg-white/95 shadow-sm p-4 xs:p-5 mb-6 border border-slate-100">
        <p className="text-slate-800 font-medium flex items-center gap-2 mb-2">
          <IconClock className="w-5 h-5 text-slate-500 flex-shrink-0" />
          Вторник 11:00–13:00
        </p>
        <p className="text-slate-700 flex items-center gap-2 mb-2">
          <IconMapPin className="w-5 h-5 text-slate-500 flex-shrink-0" />
          The Seed Church, Пхукет
        </p>
        <a
          href="https://maps.app.goo.gl/PzT3wFxCMuEDkPtz7?g_st=ipc"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm font-medium text-[var(--color-accent)] no-underline"
        >
          Открыть карту
          <IconChevronRight className="w-4 h-4" />
        </a>
      </div>

      {/* Placeholder: кнопка — пока заглушка, мероприятия потом */}
      <div className="rounded-2xl overflow-hidden bg-white/80 backdrop-blur-sm shadow-sm p-6 text-center border border-slate-100">
        <p className="text-slate-500 text-sm font-medium uppercase tracking-wider">
          Скоро
        </p>
        <p className="text-slate-600 text-sm mt-1">
          Регистрация и мероприятия появятся здесь
        </p>
      </div>

      <div className="mt-6">
        <Link
          to="/schedule"
          className="flex items-center justify-between gap-3 py-4 px-4 rounded-xl bg-white/95 shadow-sm border border-slate-100 active:bg-slate-50 transition-colors no-underline text-inherit"
        >
          <span className="font-medium text-slate-800">
            Всё расписание на неделю
          </span>
          <IconChevronRight className="w-5 h-5 text-slate-300 flex-shrink-0" />
        </Link>
      </div>

      <div className="h-4" />
    </Layout>
  );
}
